import { render, staticRenderFns } from "./BeSelect.vue?vue&type=template&id=652dddf9&scoped=true"
import script from "./BeSelect.vue?vue&type=script&lang=js"
export * from "./BeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652dddf9",
  null
  
)

export default component.exports